import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  plantedAcres: null,
  selectedPlantedAcre: null,
  editedPlantedAcre: null,
  savedPlantedAcre: null,
  savePlantedAcreSuccess: false,
  plantedAcreMode: "",
};

const plantedAcresSlice = createSlice({
  name: "plantedAcres",
  initialState,
  reducers: {
    setPlantedAcres: (state, action) => {
      state.plantedAcres = action.payload;
    },
    setSelectedPlantedAcre: (state, action) => {
      state.selectedPlantedAcre = action.payload;
    },
    setEditedPlantedAcre: (state, action) => {
      state.editedPlantedAcre = action.payload;
    },
    setSavedPlantedAcre: (state, action) => {
      state.savedPlantedAcre = action.payload;
    },
    setSavePlantedAcreSuccess: (state, action) => {
      state.savePlantedAcreSuccess = action.payload;
    },
    setPlantedAcreMode: (state, action) => {
      state.plantedAcreMode = action.payload;
    },
  },
});

export const {
  setPlantedAcres,
  setSelectedPlantedAcre,
  setEditedPlantedAcre,
  setSavedPlantedAcre,
  setSavePlantedAcreSuccess,
  setPlantedAcreMode,
} = plantedAcresSlice.actions;
export default plantedAcresSlice.reducer;
